/*@ngInject*/
export default ['moment', '$translate',  function (moment, $translate){
    return {
        parseHoursToMinutes: (hours) => {
            let momentTime = moment.duration(hours, 'hours');
            return momentTime.hours() + (momentTime.days() * 24) + 'h ' + ("0" + momentTime.minutes()).slice(-2) + $translate.instant('MINUTES_SHORT');
        },
        parseHoursToSeconds: (hours) => {
            let momentTime = moment.duration(hours, 'hours');
            return momentTime.hours() + 'h ' + ("0" + momentTime.minutes()).slice(-2) + $translate.instant('MINUTES_SHORT') + " " + ("0" + momentTime.seconds()).slice(-2) + $translate.instant('SECONDS_SHORT');
        }
    }
}]
